import { SWMS_METHODS_URL, SWMS_METHOD_ACTIVITY_URL, SWMS_METHOD_ORDER_URL, METHOD_ITEMS_ADDITIONALS_URL, SWMS_HIGH_RISK_ACTIVITIES_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

const normalizeHighRiskActivities = (payload = {}) => {
  const categories = Array.isArray(payload.categories) ? payload.categories : [];

  return categories.map((category) => {
    const activities = Array.isArray(category && category.high_risk_activites)
      ? category.high_risk_activites
      : Array.isArray(category && category.high_risk_activities)
        ? category.high_risk_activities
        : [];

    return {
      id: category && category.id,
      category_name: category && category.category_name ? category.category_name : "",
      category_color: category && category.category_color ? category.category_color : "#c0b4ff",
      activities: [...activities].sort((first, second) => {
        const firstOrder = Number(first && first.activity_order ? first.activity_order : 0);
        const secondOrder = Number(second && second.activity_order ? second.activity_order : 0);

        if (firstOrder !== secondOrder) {
          return firstOrder - secondOrder;
        }

        return Number(first && first.id ? first.id : 0) - Number(second && second.id ? second.id : 0);
      }).map((activity) => ({
        id: activity && activity.id,
        category_id: activity && activity.category_id ? activity.category_id : category && category.id,
        activity_name: activity && activity.activity_name ? activity.activity_name : "",
        activity_order: activity && activity.activity_order ? activity.activity_order : 0,
        active: activity && activity.active,
        deleted: activity && activity.deleted
      }))
    };
  });
};



export const getSwmsMethods = (params = {}, abortController) => () => {
  return scopeApiInstance.get(
    SWMS_METHODS_URL,
    {
      params: { ...params },
      ...abortController
    }
  )
    .then((res) => {
      if (res && res.data && res.data.data) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(Strings.generic_error);
      }
    }).catch(error => {
      if (error) {
        return Promise.reject(
          error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
        );
      } else {
        return Promise.reject(null);
      }
    })
}

export const getSwmsMethodDetails = (id, params = {}, abortController) => async (dispatch) => {
  return scopeApiInstance.get(
    `${SWMS_METHODS_URL}/${id}`,
    {
      params: { ...params },
      ...abortController
    }
  )
    .then((res) => {
      if (res && res.data && res.data.data) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(Strings.generic_error);
      }
    })
    .catch(error => {
      if (error) {
        return Promise.reject(
          error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
        );
      } else {
        return Promise.reject(null);
      }
    })

}

export const getSwmsMethodHighRiskActivities = (abortController) => async () => {
  return scopeApiInstance.get(
    SWMS_HIGH_RISK_ACTIVITIES_URL,
    {
      ...abortController
    }
  )
    .then((res) => {
      if (res && res.data && res.data.data) {
        return Promise.resolve(normalizeHighRiskActivities(res.data.data));
      }

      return Promise.reject(Strings.generic_error);
    })
    .catch(error => {
      if (error) {
        return Promise.reject(
          error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
        );
      }

      return Promise.reject(null);
    });
}

export const addEditSwmsMethod = (formData) => async () => {
  const method = formData.id ? scopeApiInstance.put : scopeApiInstance.post
  const url = formData.id ? `${SWMS_METHODS_URL}/${formData.id}` : SWMS_METHODS_URL
  return method(url, formData)
    .then(res => {
      if (res.data.status) {
        return Promise.resolve(res.data.message);
      }
    })
    .catch(error => {
      if (error) {
        return Promise.reject(
          error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
        );
      } else {
        return Promise.reject(null);
      }
    })
}

export const changeMethodOrder = (formData) => async () => {
  return scopeApiInstance.patch(SWMS_METHOD_ORDER_URL, formData)
    .then(res => {
      if (res.data.status) {
        return Promise.resolve(res.data.message);
      }
    })
    .catch(error => {
      if (error) {
        return Promise.reject(
          error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
        );
      } else {
        return Promise.reject(null);
      }
    })
}

export const getMethodItemsAdditionals = (abortController) => async () => {
  return scopeApiInstance.get(METHOD_ITEMS_ADDITIONALS_URL)
    .then((res) => {
      if (res && res.data && res.data.data) {
        return Promise.resolve(res.data.data);
      }

      return Promise.resolve([]);
    })
    .catch(error => {
      if (error) {
        return Promise.reject(
          error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
        );
      }

      return Promise.reject(null);
    });
}

export const changeActivityOrder = (formData) => async () => {
  return scopeApiInstance.patch(SWMS_METHOD_ACTIVITY_URL, formData)
    .then(res => {
      if (res.data.status) {
        return Promise.resolve(res.data.message);
      }
    })
    .catch(error => {
      if (error) {
        return Promise.reject(
          error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
        );
      } else {
        return Promise.reject(null);
      }
    })
}

